import { memo, useCallback, useRef, useState } from "react";
import PropTypes from "prop-types";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import IconSuccessLink from "app/pages/.shared/static/icons/IconSuccessLink";
import "./SmartDPHeroCommercialTag.scss";

const IconClipboard = props => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.91665 0.91626C9.26807 0.91626 10.3476 0.915366 11.202 1.01636C12.0728 1.1193 12.8069 1.33716 13.4236 1.84318C13.6303 2.01285 13.8204 2.20282 13.9901 2.40959C14.4696 2.99402 14.6903 3.68402 14.7998 4.49618C14.8845 5.12475 14.9065 5.87368 14.9129 6.7618C15.3854 6.77396 15.8062 6.79824 16.1767 6.84806C16.9406 6.95079 17.6029 7.17313 18.1315 7.70174C18.6601 8.23037 18.8824 8.89267 18.9852 9.65649C19.085 10.3989 19.0836 11.3426 19.0836 12.4999V13.3333C19.0836 14.4905 19.085 15.4343 18.9852 16.1767C18.8824 16.9405 18.6601 17.6028 18.1315 18.1314C17.6029 18.6601 16.9406 18.8824 16.1767 18.9851C15.4344 19.0849 14.4906 19.0836 13.3333 19.0836H12.5C11.3427 19.0836 10.3989 19.0849 9.65656 18.9851C8.89273 18.8824 8.23043 18.66 7.7018 18.1314C7.17319 17.6028 6.95085 16.9405 6.84812 16.1767C6.7983 15.8061 6.77402 15.3853 6.76186 14.9128C5.87374 14.9065 5.12481 14.8844 4.49624 14.7997C3.68408 14.6903 2.99408 14.4696 2.40965 13.99C2.20289 13.8203 2.01292 13.6303 1.84324 13.4236C1.33722 12.8069 1.11936 12.0727 1.01642 11.2019C0.915427 10.3475 0.916321 9.26801 0.916321 7.91659C0.916321 6.56517 0.915427 5.48565 1.01642 4.63127C1.11936 3.76043 1.33721 3.02629 1.84324 2.40959C2.01292 2.20284 2.20287 2.01287 2.40965 1.84318C3.02635 1.33715 3.76049 1.1193 4.63133 1.01636C5.48572 0.915366 6.56523 0.91626 7.91665 0.91626ZM12.5 8.25024C11.3003 8.25024 10.4759 8.25163 9.85675 8.33488C9.25916 8.41523 8.96574 8.55858 8.76219 8.76213C8.55864 8.96568 8.41529 9.2591 8.33494 9.85669C8.25169 10.4759 8.25031 11.3002 8.25031 12.4999V13.3333C8.25031 14.533 8.25169 15.3573 8.33494 15.9765C8.41529 16.5741 8.55864 16.8675 8.76219 17.071C8.96575 17.2746 9.25917 17.4179 9.85675 17.4983C10.4759 17.5815 11.3003 17.5829 12.5 17.5829H13.3333C14.533 17.5829 15.3574 17.5815 15.9765 17.4983C16.5741 17.4179 16.8676 17.2746 17.0711 17.071C17.2747 16.8675 17.418 16.5741 17.4984 15.9765C17.5816 15.3573 17.583 14.533 17.583 13.3333V12.4999C17.583 11.3002 17.5816 10.4759 17.4984 9.85669C17.418 9.25911 17.2747 8.96568 17.0711 8.76213C16.8676 8.55858 16.5741 8.41523 15.9765 8.33488C15.3574 8.25163 14.533 8.25024 13.3333 8.25024H12.5ZM7.91665 2.41691C6.52849 2.41691 5.55299 2.41745 4.80711 2.50562C4.07795 2.59183 3.66615 2.7524 3.36098 3.00285C3.23021 3.11016 3.11026 3.23012 3.00291 3.36092C2.75246 3.66609 2.59189 4.07789 2.50568 4.80705C2.41751 5.55293 2.41697 6.52843 2.41697 7.91659C2.41697 9.30475 2.41751 10.2802 2.50568 11.0261C2.59189 11.7553 2.75245 12.1671 3.00291 12.4722C3.11024 12.603 3.23019 12.723 3.36098 12.8303C3.65047 13.0679 4.03598 13.2239 4.69643 13.3129C5.22868 13.3846 5.88759 13.4055 6.74965 13.4122V12.4999C6.74965 11.3426 6.74831 10.3989 6.84812 9.65649C6.95085 8.89268 7.17319 8.23037 7.7018 7.70174C8.23044 7.17313 8.89274 6.95079 9.65656 6.84806C10.3989 6.74825 11.3427 6.74959 12.5 6.74959H13.4123C13.4055 5.88753 13.3847 5.22862 13.313 4.69637C13.224 4.03592 13.068 3.65041 12.8304 3.36092C12.7231 3.23015 12.6031 3.1102 12.4723 3.00285C12.1671 2.75239 11.7553 2.59183 11.0262 2.50562C10.2803 2.41745 9.30481 2.41691 7.91665 2.41691Z"
			fill="white"
		/>
	</svg>
);

const SmartDPHeroCommercialTag = ({ tag }) => {
	const [copied, setCopied] = useState(false);
	const textRef = useRef(null);

	const copyText = useCallback(event => {
		if (event?.stopPropagation) {
			event.stopPropagation();
		}

		if (!tag) {
			return;
		}

		if (!navigator?.clipboard?.writeText) {
			return;
		}

		navigator.clipboard
			.writeText(tag)
			.then(() => {
				setCopied(true);
				setTimeout(() => {
					setCopied(false);
				}, 2000);
			})
			.catch(() => {});
	}, []);

	const handleKeyDown = useCallback(
		event => {
			if (event.key === "Enter" || event.key === " ") {
				event.preventDefault();
				copyText(event);
			}
		},
		[copyText]
	);

	if (!tag) {
		return null;
	}

	const icon = copied ? (
		<IconSuccessLink width={20} height={20} />
	) : (
		<IconClipboard width={20} height={20} />
	);

	return (
		<Typography
			variant={TYPOGRAPHY_VARIANTS.REGULAR}
			variantMD={TYPOGRAPHY_VARIANTS.XL}
			variantLG={TYPOGRAPHY_VARIANTS.XL3}
			isBold
			className="smartDP-hero-commercial__tag"
			data-testid="smartDP-hero-commercial-tag"
			component="div"
			onClick={copyText}
			onKeyDown={handleKeyDown}
			role="button"
			tabIndex={0}
			aria-label="Copy to clipboard"
		>
			<span ref={textRef}>{tag}</span>
			<span className="smartDP-hero-commercial__tag-icon">{icon}</span>
		</Typography>
	);
};

SmartDPHeroCommercialTag.propTypes = {
	tag: PropTypes.node,
};

export default memo(SmartDPHeroCommercialTag);
